import axiosInstance from "./api_helper";

export const createReglement = async (reglement) => {
  try {
    const response = await axiosInstance.post('/api/reglements', JSON.stringify(reglement));
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateReglement = async (id, reglement) => {
  try {
    const response = await axiosInstance.put(`/api/reglements/${id}`, JSON.stringify(reglement));
    return response;
  } catch (error) {
    throw error;
  }
};

export const solderImpaye = async (reglId) => {
  return await axiosInstance.get(`/api/reglements/solder/${reglId}`);
};

export const getReglements = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/api/reglements', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getEcheancesClients = async ({ clientId, dateFrom, dateTo, statut }) => {
  try {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    const response = await axiosInstance.get('/api/reglements/client/echeance', { params });
    return response;
  } catch (error) {
    throw error;
  }
};


export const getCautionsClients = async ({ clientId, dateFrom, dateTo, statut }) => {
  try {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    const response = await axiosInstance.get('/api/reglements/client/caution', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const encaisserReglement = async (id, encaissement) => {
  try {
    const response = await axiosInstance.post(`/api/reglements/${id}/encaisser`, JSON.stringify(encaissement));
    return response;
  } catch (error) {
    throw error;
  }
};

export const annulerReglement = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/reglements/${id}/annuler`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const allocateAvance = async (reglementId) =>
  axiosInstance.post(`/api/reglements/${reglementId}/allouer`);

export const getAllocationsByReglement = async (reglementId) =>
  axiosInstance.get(`/api/reglements/${reglementId}/allocations`);



export const getReglementsByInvoice = async (numero) => {
  const params = {};
  if (numero) params.numero = numero;
  return await axiosInstance.get(`/api/reglements/facture`, { params });
};

export const getReglementById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/reglements/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteReglement = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/reglements/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getReglementsByClient = async (clientId, page = 0, size = 20, sortBy = 'dateReglement', sortDirection = 'desc') => {
  try {
    const response = await axiosInstance.get(`/api/reglements/client/${clientId}`, {
      params: { page, size, sortBy, sortDirection }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const rechercherReglements = async ({ clientId, chantierId, commercialId, dateFrom, dateTo, statut, query, modeReglement, page, size }) => {
  try {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (chantierId !== undefined && chantierId !== null) params.chantierId = chantierId;
    if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    if (query) params.query = query;
    if (modeReglement) params.mode = modeReglement;
    if (page !== undefined && page !== null) params.page = page;
    if (size !== undefined && size !== null) params.size = size;

    const response = await axiosInstance.get('/api/reglements/rechercher', { params });

    return response;
  } catch (error) {
    throw error;
  }
};

export const rechercherReglementsTotals = async ({ clientId, shiftId, commercialId, dateFrom, dateTo, statut, modeReglement, mode, query } = {}) => {
  try {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (shiftId !== undefined && shiftId !== null) params.shiftId = shiftId;
    if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    if (query) params.query = query;
    if (modeReglement) params.mode = modeReglement;
    if (mode) params.mode = mode;

    const response = await axiosInstance.get('/api/reglements/totals', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllocations = async ({ dateFrom, dateTo, mode, query }) => {
  try {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (query) params.query = query;
    if (mode) params.mode = mode;


    const response = await axiosInstance.get('/api/reglements/allocations/rechercher', { params });

    return response;
  } catch (error) {
    throw error;
  }
};

export const avanceClient = async ({ clientId, dateFrom, dateTo, query, shiftId, commercialId }) => {
  try {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (clientId) params.clientId = clientId;
    if (shiftId) params.shiftId = shiftId;
    if (commercialId) params.commercialId = commercialId;
    if (dateTo) params.dateTo = dateTo;
    if (query) params.query = query;

    const response = await axiosInstance.get('/api/reglements/rechercher', { params });

    return response;
  } catch (error) {
    throw error;
  }
};

export const getFacturesImpayees = async ({ clientId }) => {
  try {
    const response = await axiosInstance.get(`/api/ventes/factures/impayees/${clientId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBonLivraisonsNonRegles = async ({ clientId }) => {
  try {
    const response = await axiosInstance.get(`/api/ventes/bon-livraisons/non-regles/${clientId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
